interface CurrencyRates {
  [key: string]: number;
}

export class CurrencyCalculator {
  convertCurrency(amount: number, fromCurrency: string, toCurrency: string, rates: CurrencyRates): number {
    if (!amount || isNaN(amount)) return 0;
    if (!fromCurrency || !toCurrency) return amount;
    if (fromCurrency.toLowerCase() === toCurrency.toLowerCase()) return amount;
    if (!rates || !rates[fromCurrency] || !rates[toCurrency]) {
      return amount;
    }

    // convert amount to USD base first
    const amountInUSD = amount / rates[fromCurrency];

    // then convert from USD to target currency
    const converted = amountInUSD * rates[toCurrency];

    return converted;
  }
}
